import { Button } from "@mui/material"

export const getEmployeeTableColumns = (handleBreakdownClick) => [
  { headerName: "Employee Name", field: "name", width: 180 },
  // { headerName: "Employee Id", field: "id" },
  // { headerName: "Store", field: "store", width: 210 },
  {
    headerName: "Incentives",
    field: "incentives",
    width: 130,
    valueGetter: (_v) => "$ " + parseFloat(_v || 0).toFixed(2),
  },

  {
    headerName: "Action",
    field: "actions",
    width: 180,
    renderCell: (params) => <Button onClick={() => handleBreakdownClick(params.row)}> View Breakdown </Button>,
  },
]

export const EmployeeTableKey = ["id"]

export const EmployeeIncentiveTableColumns = [
  { headerName: "Rule Name", field: "rule_name", width: 250 },
  { headerName: "Rule Value", field: "total_rule_value", width: 180 },
  { headerName: "Payout Tier", field: "payout_tier", width: 220 },
  { headerName: "Payout Value", field: "payout_value", width: 160 },
  { headerName: "Incentives", field: "incentive", width: 160 },
]

export const EmployeeIncentiveBreakdownTableColumns = [
  { headerName: "Transaction Id", field: "trans_id", width: 180 },
  { headerName: "Customer", field: "customer", width: 180 },
  { headerName: "Production Description", field: "product_desc", width: 350 },
  { headerName: "Mobile", field: "mobile", width: 180 },
  { headerName: "Rule Name", field: "rule_name", width: 180 },
  { headerName: "Incentive", field: "incentive", width: 180 },
  { headerName: "Incentive Date", field: "incentive_date", width: 230 },
]

export const EmployeeIncentiveTableKey = ["rule_name"]

// module.exports = {
//     getAppealTableColumns,
//     AppealsTableKey,
// }
